import { createContext, useContext } from 'react';

import type { AccountProfile } from '../api/types';

export type AuthState = {
  account: AccountProfile | null;
  isLoading: boolean;
  signIn: (email: string, password: string) => Promise<void>;
  signOut: () => Promise<void>;
};

export const AuthContext = createContext<AuthState>({
  account: null,
  isLoading: true,
  signIn: async () => undefined,
  signOut: async () => undefined,
});

export const useAuth = (): AuthState => useContext(AuthContext);
